import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import {ReactComponent as HeaderIcon} from "assets/images/icon/headerIcon.svg";
import {ReactComponent as HumanIcon} from "assets/images/icon/humanIcon.svg";
import {getReptName, selectBtnEvent} from "utils/CommonUtils";


const Header = React.memo(() => {
  useEffect(() => {
    // storage 변경 막기
    window.addEventListener('storage', (e) => {
      if (["userId", "token", "userType", "channel", "reptName"].includes(e.key)) {
        logoutEvent();
      }
    });
    // select 활성화 이벤트
    document.addEventListener("click", selectBtnEvent);
  }, []);

  // 대표자명 조회
  const reptName = getReptName();

  // 로그아웃
  const logoutEvent = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.location.href = "/";
  }

  // 네비 활성화
  const menuBtnEvent = () => {
    if (window.innerWidth <= 700) {
      if(document.getElementById("subNavigate").classList.contains("active")) {
        document.getElementById("subNavigateHide").classList.remove("active");
        document.getElementById("subNavigate").classList.remove("active");
      } else {
        document.getElementById("subNavigateHide").classList.add("active");
        document.getElementById("subNavigate").classList.add("active");
      }
    }
  }

  return (
    <>
      <header className="header bg-lightgray pr-20 pl-25">
        <div className="innerV2 headerBox d-flex j-between a-center">
          <h1 className="headerLogo mt-15">
            <Link to="/v2/shopInfo1" className="blockBox">
              <HeaderIcon width={234} />
            </Link>
          </h1>
          <div className="headerTopMenuBox d-flex j-between a-center">
            <p className="flexBox mr-20 fs-17 fc-blue userName">
              <HumanIcon width={23} />
              <span className="ml-15 fw-7">{reptName}</span>
              사장님, 반갑습니다!
            </p>
            <button id="logoutBtn" className="fs-15 fw-7 fc-blue border-gray" onClick={logoutEvent}>로그아웃</button>
            <button id="menuBtn" className="fs-15 fw-7 fc-blue ml-10 border-gray" onClick={menuBtnEvent}>메뉴</button>
          </div>
        </div>
      </header>
      <div className="loading hide"></div>
    </>
  );
});

export default Header;